import { useState } from "react";
import { X, Rocket, Loader2 } from "lucide-react";
import { checkoutBoost } from "../lib/api";
import { getStoredEmail } from "../lib/useNewsezeUser";

export default function BoostModal({ defaultSubject = "", onClose, onNeedSubscribe }) {
  const email = getStoredEmail();
  const [subject, setSubject] = useState(defaultSubject);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const buy = async () => {
    setErr("");
    if (!email) { onNeedSubscribe?.(); return; }
    const s = subject.trim();
    if (!s) { setErr("Pick a subject to boost (e.g. AI regulation, Tesla, FOMC)."); return; }
    setBusy(true);
    try {
      const { url } = await checkoutBoost({ email, subject: s, origin_url: window.location.origin });
      window.location.href = url;
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not start checkout.");
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/55 flex items-center justify-center p-4" onClick={onClose} data-testid="boost-modal">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-[520px] border border-[var(--line)]">
        <div className="flex items-center justify-between p-5 border-b border-[var(--line)]">
          <div>
            <div className="text-[11px] uppercase tracking-[0.18em] font-black text-[var(--gold)]">Boost a Subject</div>
            <h2 className="text-[20px] font-black tracking-[-0.02em]">$9 · 30-day priority placement</h2>
          </div>
          <button onClick={onClose} aria-label="Close" className="p-2 -mr-2"><X /></button>
        </div>

        <div className="p-5 space-y-4">
          <p className="text-[14px] text-[var(--ink)] leading-snug">
            Bump one subject to the top of your Buildeze feed for 30 days. You also earn{" "}
            <b>2× attention credits</b> on every story that matches it.
          </p>

          <div>
            <label className="text-[11px] uppercase tracking-[0.14em] font-bold text-[var(--muted)]">Subject</label>
            <input
              autoFocus
              type="text"
              value={subject}
              maxLength={120}
              placeholder="e.g. AI regulation, Tesla, FOMC, climate"
              className="field w-full mt-1"
              onChange={(e) => setSubject(e.target.value)}
              data-testid="boost-subject-input"
            />
          </div>

          {err && <div className="text-[13px] text-[var(--red,#b91c1c)]" data-testid="boost-error">{err}</div>}

          <button onClick={buy} disabled={busy} className="btn gold w-full justify-center" data-testid="boost-buy">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <><Rocket size={14} /> Boost for $9 · 30 days</>}
          </button>
          <div className="text-[11px] text-[var(--muted)] text-center">
            Newseze Pro members boost unlimited subjects free. <span className="underline cursor-pointer">Upgrade →</span>
          </div>
        </div>
      </div>
    </div>
  );
}
